<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllStockBalance('printStockBalance')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockBalance()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>
            Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                label="Cateogry"
                v-model="queryParams.categoryId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                label="Brand"
                v-model="queryParams.brandId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex
              sm6
              v-if="
                user.roleName == 'ADMIN' ||
                  user.roleName == 'GENERAL_MANAGER' ||
                  user.roleName == 'WAREHOUSE_MANAGER' ||
                  user.roleName == 'FINANCE_MANAGER' ||
                  user.roleName == 'PROCUREMENT_MANAGER' ||
                  user.role.roleName == 'BRANCH_ADMIN' ||
                  user.roleName == 'PRODUCTION_MANAGER' ||
                  user.roleName == 'ASSET_MANAGER'
              "
            >
              <v-autocomplete
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
                multiple
                @change="setBin()"
                :readonly="
                  user.role.roleName == 'BRANCH_ADMIN' ||
                    user.roleName == 'WAREHOUSE_MANAGER' ||
                    user.roleName == 'PRODUCTION_MANAGER' ||
                    (user.roleName == 'PROCUREMENT_MANAGER' &&
                      user.warehouseId) ||
                    user.roleName == 'ASSET_MANAGER'
                "
              ></v-autocomplete>
            </v-flex>
            <v-flex
              sm3
              sm6
              v-if="
                user.roleName == 'ADMIN' ||
                  user.roleName == 'GENERAL_MANAGER' ||
                  user.roleName == 'WAREHOUSE_MANAGER' ||
                  user.roleName == 'FINANCE_MANAGER' ||
                  user.roleName == 'PROCUREMENT_MANAGER' ||
                  user.roleName == 'WAREHOUSE_STAFF' ||
                  user.roleName == 'PRODUCTION_MANAGER' ||
                  user.roleName == 'ASSET_MANAGER'
              "
            >
              <v-autocomplete
                :items="bins"
                label="Bin"
                v-model="queryParams.binId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productGroupList"
                label="Product Group"
                v-model="queryParams.productGroupId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="balanceTypeList"
                label="Balance"
                v-model="queryParams.balanceType"
                item-text="text"
                item-value="value"
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="stockLevelList"
                label="Stock Level"
                v-model="queryParams.stockLevelType"
                item-text="text"
                item-value="value"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouse.name }}</td>
              <td>{{ props.item.binName }}</td>
              <td>{{ props.item.product.name }}</td>
              <td>{{ props.item.product.code }}</td>
              <td>{{ props.item.category.name }}</td>
              <td>{{ props.item.product.productGroupName }}</td>
              <td>{{ props.item.brand.name }}</td>
              <td>{{ props.item.qcNo }}</td>
              <td>{{ props.item.batchNo }}</td>
              <td>
                {{ props.item.stockInDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>
                {{ props.item.expDateInMilliSeconds | formatMsDate }}
              </td>
              <td>
                {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.qtyStr }}</td>
              <td style="text-align: right">
                {{ props.item.qty | decFormat(6) }}
              </td>
              <td>
                <v-btn color="primary" @click="showDetail(props.item)"
                  >Detail</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Product list dialog -->
    <v-dialog v-model="showDetailDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="detailqueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="detailqueryParams.fromDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="detailqueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="detailqueryParams.toDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm1></v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="detailqueryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="transactionstatusList"
                label="Transaction Type"
                v-model="detailqueryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchDetail">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card>
            <v-card-text class="font-weight-bold">
              <div>
                <span>Product Code :</span>
                <v-chip>
                  <span>{{ productCode }}</span>
                </v-chip>

                <span>Product Name :</span>
                <v-chip>
                  <span>{{ productName }}</span>
                </v-chip>
                <span>QC No :</span>
                <v-chip>
                  <span>{{ qcNo }}</span>
                </v-chip>
                <span>Batch No :</span>
                <v-chip>
                  <span>{{ batchNo }}</span>
                </v-chip>
              </div>
              <div>
                <span>Warehouse Name :</span>
                <v-chip>
                  <span>{{ warehouseName }}</span>
                </v-chip>

                <span>In/Out/Total:</span>
                <v-chip>
                  <span
                    >{{ inQty | decFormat(6) }}/{{ outQty | decFormat(6) }}/{{
                      totalQty | decFormat(6)
                    }}</span
                  >
                </v-chip>
                <v-btn
                  :loading="printAllButtonLoading"
                  color="primary"
                  @click="printStockBalanceDetail('printStockBalanceDetail')"
                  >PRINT ALL</v-btn
                >
                <v-btn
                  color="success"
                  :loading="printAllButtonLoading"
                  @click="exportStockBalanceDetail()"
                  >EXPORT ALL</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="detailheaders"
                :items="detailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRowsDetail"
                :rows-per-page-items="rowsPerDetailPageItems"
                :pagination.sync="detailPagination"
                :must-sort="false"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{
                      props.item.stockBalanceDetail.issueDateInMilliSeconds
                        | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.stockBalanceDetail.issueNo }}</td>
                  <td>{{ props.item.stockBalanceDetail.transactionType }}</td>
                  <td>{{ props.item.stockBalanceDetail.binName }}</td>
                  <td style="text-align: right">
                    {{ props.item.stockBalanceDetail.qty | decFormat(6) }}
                  </td>
                  <td>{{ props.item.stockBalanceDetail.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <summary report> -->
    <div
      id="printStockBalance"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock Balance Report</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">Bin</th>
              <th style="border: 1px solid black; text-align: center">
                Product Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody v-for="(stockPage, index) in allStockList" :key="index">
            <tr v-for="(item, i) in stockPage.stockList" :key="i">
              <td
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-if="i == 0"
              >
                {{ stockPage.warehouseName }}
              </td>
              <td
                v-else
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              ></td>
              <td
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-if="i == 0"
              >
                {{ stockPage.binName }}
              </td>
              <td
                v-else
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qtyStr }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <summary report> -->
    <div
      id="printStockBalanceDetail"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock Balance Detail Report</p>
      </div>
      <br />
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Product Code: {{ productCode }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Product Name : {{ productName }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Warehouse Name : {{ warehouseName }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          In Qty/Out Qty/Total Qty : {{ inQty }}/{{ outQty }}/{{ totalQty }}
        </p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">Transaction Type</th>
              <th style="text-align: left">Qty</th>
              <th style="text-align: left">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allDetailList" :key="index">
              <td style="text-align: left">
                {{
                  item.stockBalanceDetail.issueDateInMilliSeconds
                    | formatMsDateTime
                }}
              </td>
              <td style="text-align: left">
                {{ item.stockBalanceDetail.issueNo }}
              </td>
              <td style="text-align: left">
                {{ item.stockBalanceDetail.transactionType }}
              </td>
              <td style="text-align: right">
                {{ item.stockBalanceDetail.qty | decFormat(6) }}
              </td>
              <td style="text-align: left">
                {{ item.stockBalanceDetail.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { warehouseService } from "../../services/warehouse-service";
import { productGroupService } from "../../services/product-group-service";
import { commonService } from "../../services/common-service";

export default {
  name: "StockList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Stock Balance Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Warehouse", align: "left", value: "warehouseName" },
      { text: "Bin", value: "binName" },
      { text: "Product Name", value: "productName" },
      { text: "Product Code", value: "productCode" },
      { text: "Category", value: "product.category.name", sortable: false },
      {
        text: "Product Group",
        value: "product.productGroup.name",
        sortable: false,
      },
      { text: "Brand", value: "product.brand.name", sortable: false },
      { text: "QC No", value: "qcNo" },
      { text: "Batch No", value: "batchNo" },
      { text: "Stock In Date", value: "stockInDate" },
      { text: "Exp Date", value: "expDate" },
      { text: "Mfg Date", value: "mfgDate" },
      { text: "Qty", value: "qty", sortable: false },
      { text: "Basic Qty", value: "basicQty", sortable: false },
      { text: "Detail", value: "Detail", sortable: false },
    ],
    binstockheaders: [
      { text: "Bin", align: "left", value: "binName" },
      { text: "Brand", value: "product.brand.name" },
      { text: "Qty", value: "qty" },
    ],
    detailheaders: [
      { text: "Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Transaction Type", value: "transactionType" },
      { text: "Bin", value: "binName", sortBy: false },
      { text: "Qty", value: "qty" },
      { text: "Description", value: "description" },
    ],
    balanceTypeList: [
      { text: "ALL", value: "" },
      { text: "With Balance", value: "WITHBALANCE" },
      { text: "Without Balance", value: "WITHOUTBALANCE" },
    ],
    transactionstatusList: [
      { label: "----All----", value: "" },
      { label: "STOCK IN", value: "STOCK IN" },
      { label: "STOCK TRANSFER IN", value: "STOCK TRANSFER IN" },
      { label: "STOCK TRANSFER OUT", value: "STOCK TRANSFER OUT" },
      { label: "STOCK ADJUSTMENT IN", value: "STOCK ADJUSTMENT IN" },
      { label: "STOCK ADJUSTMENT OUT", value: "STOCK ADJUSTMENT OUT" },
      { label: "STOCK ISSUE", value: "STOCK ISSUE" },
      { label: "WHOLE SALE", value: "WHOLE SALE" },
      { label: "WHOLE SALE FOC", value: "WHOLE SALE FOC" },
      // { label: "WHOLE SALE RETURN", value: "WHOLE SALE RETURN" },
      { label: "WAY SALE", value: "WAY SALE" },
      { label: "WAY SALE FOC", value: "WAY SALE FOC" },
      { label: "WAY SALE RETURN", value: "WAY SALE RETURN" },
      { label: "WAY SALE EXCHANGE", value: "WAY SALE EXCHANGE" },
      { label: "RETAIL SALE", value: "RETAIL SALE" },
      { label: "RETAIL SALE FOC", value: "RETAIL SALE FOC" },
      { label: "RETAIL SALE RETRUN", value: "RETAIL SALE RETURN" },
      { label: "LOCATION MOVEMENT IN", value: "LOCATION MOVEMENT IN" },
      { label: "LOCATION MOVEMENT OUT", value: "LOCATION MOVEMENT OUT" },
      { label: "SALE RETURN", value: "SALE RETURN" },
      { label: "PRODUCTION IN", value: "PRODUCTION IN" },
      { label: "PRODUCTION OUT", value: "PRODUCTION OUT" },
    ],
    stockLevelList: [
      { text: "--All--", value: "" },
      { text: "MAX QTY", value: "MAX_QTY" },
      { text: "MIN QTY", value: "MIN_QTY" },
      { text: "REORDER QTY", value: "REORDER_QTY" },
    ],
    rowsPerPageItems: [25, 50, 100],
    rowsPerDetailPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "warehouseName",
      totalItems: 0,
    },
    detailPagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: "warehouseName",
      totalItems: 0,
    },

    buttonLoading: false,
    printAllButtonLoading: false,
    stockList: [],
    allStockList: [],
    detailList: [],
    detailbinStockList: [],
    allDetailList: [],
    categoryList: [],
    brandList: [],
    warehouseList: [],
    productGroupList: [],
    bins: [],
    binList: [],

    totalRows: 0,
    totalRowsDetail: 0,
    showDetailDialog: false,
    showBinStocksDialog: false,
    productCode: "",
    productName: "",
    warehouseName: "",
    qcNo: "",
    batchNo: "",
    factorunitName: "",
    inQty: 0,
    outQty: 0,
    totalQty: 0,
    queryParams: {
      productCode: "",
      productName: "",
      categoryId: "",
      brandId: "",
      warehouseId: [],
      productGroupId: "",
      binId: "",
      balanceType: "",
      stockLevelType: "",
      binIds: [],
    },
    clonequeryParams: new Object(),
    detailqueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      type: "",
      productId: "",
      warehouseId: "",
      binIds: [],
      qcNo: "",
      batchNo: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockList();
      },
      deep: true,
    },
    detailPagination: {
      handler() {
        this.getDetailList();
      },
      deep: true,
    },
  },
  created() {
    if (
      this.user.role.roleName == "BRANCH_ADMIN" ||
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "PROCUREMENT_MANAGER"
    ) {
      this.queryParams.warehouseId = [this.user.warehouseId];
      this.clonequeryParams = Object.assign({}, this.queryParams);
    } else if (this.user.role.roleName == "WAREHOUSE_STAFF") {
      this.queryParams.warehouseId = [this.user.warehouseId];
      this.bins = this.user.selectedBinList;
      this.user.selectedBinList.forEach((v) =>
        this.queryParams.binIds.push(v.id)
      );
      this.clonequeryParams = Object.assign({}, this.queryParams);
    } else if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseId = [this.user.shop.warehouseId];
      this.clonequeryParams = Object.assign({}, this.queryParams);
    }
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.productName) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.binId) {
      this.queryParams.binId = this.$route.query.binId;
    }
    if (this.$route.query.productGroupId) {
      this.queryParams.productGroupId = this.$route.query.productGroupId;
    }
    if (this.$route.query.balanceType) {
      this.queryParams.balanceType = this.$route.query.balanceType;
    }
    if (this.$route.query.stockLevelType) {
      this.queryParams.stockLevelType = this.$route.query.stockLevelType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getCategoryList();
    this.getBrandList();
    this.getProductGroupList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stock-balances", query: this.queryParams });
      this.getStockList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    onSearchDetail() {
      this.showListLoading = true;
      this.buttonLoading = true;
      this.$router.replace({
        name: "stock-balances",
        query: this.detailqueryParams,
      });
      this.getDetailList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    getDetailList() {
      //let order = this.pagination.descending ? "desc" : "asc";
      this.detailList = [];
      this.totalQty = 0;
      this.inQty = 0;
      this.outQty = 0;
      stockService
        .getDetailList(
          this.detailqueryParams,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage
          // this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.detailList = res.data.stockList;
            this.totalRowsDetail = res.data.totalElements;
            this.totalQty = res.data.totalQty;
            this.inQty = res.data.inQty;
            this.outQty = res.data.outQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          if (
            this.user.role.roleName == "BRANCH_ADMIN" ||
            this.user.role.roleName == "WAREHOUSE_MANAGER" ||
            this.user.role.roleName == "PRODUCTION_MANAGER" ||
            this.user.role.roleName == "PROCUREMENT_MANAGER" ||
            this.user.role.roleName == "ASSET_MANAGER"
          ) {
            this.setBin();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBrandList() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductGroupList() {
      productGroupService
        .getAllProductGroup()
        .then((res) => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStockList() {
      this.showListLoading = true;
      this.buttonLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getStockList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockList = res.data.stockList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
        });
    },
    printAllStockBalance(divName) {
      this.printAllButtonLoading = true;
      stockService
        .getAllStockList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allStockList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    printStockBalanceDetail(divName) {
      this.showListLoading = true;
      this.buttonLoading = true;
      this.allDetailList = [];
      stockService
        .getAllDetailList(this.detailqueryParams)
        .then((res) => {
          if (res.data) {
            this.allDetailList = res.data.stockList;
            this.totalRowsDetail = res.data.totalElements;
            this.totalQty = res.data.totalQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.buttonLoading = false;
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
    },
    showDetail(stockbalance) {
      this.productCode = stockbalance.product.code;
      this.productName = stockbalance.product.name;
      this.warehouseName = stockbalance.warehouse.name;
      this.qcNo = stockbalance.qcNo;
      this.batchNo = stockbalance.batchNo;
      this.detailqueryParams.type = "";
      this.detailqueryParams.productId = stockbalance.product.id;
      this.detailqueryParams.warehouseId = stockbalance.warehouse.id;
      this.detailqueryParams.issueNo = "";
      this.detailqueryParams.binIds = stockbalance.bin.id;
      this.detailqueryParams.qcNo = stockbalance.qcNo;
      this.detailqueryParams.batchNo = stockbalance.batchNo;
      this.detailqueryParams.fromDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.detailqueryParams.toDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.showDetailDialog = !this.showDetailDialog;
      this.getWarehouseDetail(stockbalance.warehouse.id);
      this.onSearchDetail();
    },

    getWarehouseDetail(id) {
      warehouseService.getWarehouseDetail(id).then((res) => {
        this.binList = res.data.binList;
      });
    },

    exportAllStockBalance() {
      this.printAllButtonLoading = true;
      stockService
        .exportAllStockBalanceExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },

    exportStockBalanceDetail() {
      stockService
        .exportStockBalanceExcel(this.detailqueryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setBin() {
      this.bins = [];
      this.queryParams.binId = "";
      for (var i = 0; i < this.queryParams.warehouseId.length; i++) {
        let warehouse = commonService.search(
          "id",
          parseInt(this.queryParams.warehouseId[i]),
          this.warehouseList
        );
        if (warehouse.binList) {
          warehouse.binList.forEach((element) => {
            this.bins.push(element);
          });
        }
      }
    },
  },
};
</script>
